const INFO = {
	main: {
		title: "Jabu Zwane",
		name: "Jabu Zwane",
		email: "info@jabuzwane.co.za",
		phone: "061 536 3813",
		logo: "../logo.png",
	},

	socials: {
		linkedin: "https://www.linkedin.com/in/jabuzwane01/",
		facebook: "https://web.facebook.com/JabuZwaneSpeaker",
		instagram: "https://www.instagram.com/jabuzwanetalks/",
		tiktok: "https://www.tiktok.com/@jabuzwanetalks",
		Whatsapp: "https://wa.me/27615363813",
	},

	homepage: {
		title: "COUNSELLING | AWARD WINNING SPEAKER | GLOBAL AWARD WINNING LEADERSHIP COACH | MEDIA CONTRIBUTOR |  AUTHOR",
		description: "I am a Keynote Speaker, Executive Coach and Facilitator in Leadership, Effective Communication, Emotional Intelligence, Entrepreneurship, Self-Mastery Mindset, Diversity, Equity, Inclusion and Belonging (DEIB) and co-author of 4 books, solo author of Forgiveness Mindset Book Thriving Healthy Empath Book.",
	},

	about: {
		title: "About Jabu Zwane",
		description: `I am a Keynote Speaker, Executive Coach, and Facilitator specialising in Leadership, Effective Communication, Emotional Intelligence, Entrepreneurship, Self-Mastery Mindset, Diversity, Equity, Inclusion and Belonging (DEIB).

I am also the co-author of four books and the solo author of Forgiveness Mindset and Thriving Healthy Empath.

I have delivered over 1,000 talks, appeared in more than 60 TV motivation segments, and facilitated workshops for over 50 companies across 10 countries and 3 continents, including multinational corporations and institutions of higher learning.

I have developed over 40 mindset models and created the Mindset Transformation Coaching Programme. My deep desire to help people achieve consistent success, transform their lives, and become empowered through mindset development is what drives me.

My Professional Experience includes:

- Founder and Executive Director at Mindset Development Institute.
- Associate Client Partner at FranklinCovey South Africa.
- Non-Executive Director and Board Member at Preferental Technologies.
- Associate Partner at Sewells MSXI, specialising in Leadership, Effective Communication, and Emotional Intelligence.
- Founder of Success Mindset Summits.
- Director at Streetbiz Foundation.

Clients include BMW Group South Africa, Volkswagen Group South Africa, SARS, Standard Bank, Motus Finance, McCarthy Group, BIC South Africa, Momentum, Tshwane University of Technology, Accenture, WellSpan Health USA, Rose Petal Pakistan, and FNB Digital Banking.

I work across South Africa, SADC, East Africa, and the USA, and I also deliver virtual programmes to clients anywhere in the world. I am currently seeking opportunities to expand my work into the UAE, China, and the broader Asian market.`
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Explore articles by Jabu Zwane on leadership, communication, emotional intelligence, entrepreneurship, self-mastery and personal growth.",
	},

	projects: [
		{
			title: "Jack Roberts Head of Sales: Discovery",
			description:
				"He is very knowledgeable with the financial sector and as a Life coach. A true leader, led with passion at all times and was successful in his role.",
			logo: "https://cdn-icons-png.flaticon.com/512/149/149071.png"
		},

		{
			title: "Angela Chepng'eno Director: Kenya",
			description:
				"Jabulani Zwane is very knowledgeable and thoroughly skilled in his art. He effectively delivered on the topic of leadership and mindset development at a time that we really needed to adapt to changing times.",
			logo: "https://cdn-icons-png.flaticon.com/512/149/149071.png"

		},

		{
			title: "Dr W Clemmons Medical Director: USA ",
			description:
				"His ability to powerfully articulate a concept, ask the right probing questions and help you clarify your vision/purpose is impressive. Helps leaders conceptualize and put feet to a vision through rigorous objective decision making",
			logo: "https://cdn-icons-png.flaticon.com/512/149/149071.png"

		},

		{
			title: "Zinzile Luthuli (MBA) Board Chairman: DMASA",
			description:
				"His training on speaking is top-notch, and his speeches are always inspiring and impactful. I particularly appreciate the templates and cheat sheets he provides, which have been incredibly helpful in improving my communication skills.",
			logo: "https://cdn-icons-png.flaticon.com/512/149/149071.png"

		},


	],
};

export default INFO;
